/**
 * @generated SignedSource<<2102b2291055567b36b53cb09bbe6d76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAddWalletModalFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WalletSelectorFragment">;
  readonly " $fragmentType": "useAddWalletModalFragment";
};
export type useAddWalletModalFragment$key = {
  readonly " $data"?: useAddWalletModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAddWalletModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAddWalletModalFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WalletSelectorFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ba509e29d4bea544ab4378b6b67dd602";

export default node;
